module.exports = __webpack_public_path__ + "img/activity_white.6527f568.svg";